// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"657ca9e2","732":"e866ec6f","977":"f7c225b7"}[chunkId] + ".chunk.js";
};